exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-container{padding:1px 20px 16px;background-color:#fff;border:2px solid #e4e4e4;border-radius:6px;margin-top:20px;margin-left:-15px;margin-right:-15px}@media (min-width:768px){.summary-container{margin-top:0;margin-left:0;margin-right:0}}.summary-heading-title{color:#eb4e00}.summary-heading-number{background-color:#eb4e00;color:#fff}.summary-title{display:none;margin:0}@media (min-width:768px){.summary-title{display:block}}.next-btn{margin:50px auto;display:flex!important;justify-content:center}@media (min-width:1200px){.next-btn{margin:0;width:100%}}.summary-heading{display:block}.plan-summary-text{margin:0}.summary-clear-address{font-size:.875rem;text-decoration:underline}.summary-clear-address:active,.summary-clear-address:hover{text-decoration:none}.summary-space{height:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/Summary/Summary.scss
 ** module id = 1212
 ** module chunks = 0
 **/